import { Component, Host, h, Prop, type JSX } from '@stencil/core'

@Component({
    tag: 'test-buttons',
    shadow: false,
})
export class TestButtons {
    @Prop() selector: string = ''

    callAction (action: string): void {
        const node = document.querySelector(`${this.selector}`)
        console.log(node)
        if (node != null) {
            if (action === 'screenshot') {
                // @ts-expect-error node could be any other node that doesn't have goToScreenshotState function
                node.goToScreenshotState()
            } else {
                // @ts-expect-error node could be any other node that doesn't have doAction function
                node.doAction(action)
            }
        }
    }

    render (): JSX.Element {
        return (
            <Host>
                <div class='buttons'>
                    <button onClick={ () => { this.callAction('u4hu1f8kzm') }}>100.23</button>
                    <button onClick={ () => { this.callAction('ok4n4xswzu') }}>1000</button>
                    <button onClick={ () => { this.callAction('start') }}>Start</button>
                    <button onClick={ () => { this.callAction('restart') }}>reStart</button>
                    <button onClick={ () => { this.callAction('stop') }}>Stop</button>
                    <button onClick={ () => { this.callAction('pauze') }}>Pauze</button>
                    <button onClick={ () => { this.callAction('previous') }}>previous</button>
                    <button onClick={ () => { this.callAction('next') }}>next</button>
                    <button onClick={ () => { this.callAction('screenshot') }}>screenshot</button>
                </div>
            </Host>
        )
    }
}
